var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepagesubscriptionBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 90,
    viewBox: "0 0 1300 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1300,
    height: 90,
    rx: 24,
    fill: "url(#paint0_linear_796_2866)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_796_2866",
    x1: 20,
    y1: -3.01389e-7,
    x2: 1409.95,
    y2: 457.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1971B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepagesubscriptionBg);
export default __webpack_public_path__ + "static/media/homepagesubscriptionBG.ffc052a0b7b6f304d7f03e411f8e2962.svg";
export { ForwardRef as ReactComponent };